import { getStoresList } from "@/utils/findStore"
import styles from "@/components/FindAStore/index.module.scss"
import NoStoreAvailable from "./NoStoreAvailable"
import { contactClickAnalytics, emailClickAnalytics } from "./analytics"
import { useEffect, useState } from "react"

const ServiceLocatorListing = props => {
  const { storeState, staticTexts,  error, storeList } = props
  const [storeListArray, setStoreListArray] = useState(storeList)
const getStoreList = () => {
    try {
      if (storeState) {
        const response = getStoresList(storeState, undefined, true)
        response.then(resp => {
          const { statusCode, result = {} } = resp
          if (statusCode === 200) {
            const res = result.data.stores
            setStoreListArray(res)
          }
          return { statusCode }
        })
      }
    } catch (error) {
      return { statusCode: 400, message: error.message }
    }
  }
  useEffect(() => {
    getStoreList()
  }, [storeState])
  return (
     <div className={styles.findStoreLanding}>
      {storeListArray && storeListArray.length > 0 ? (
        <>
          <div className="find-a-store__store-city">{storeState}</div>
          <hr className="find-a-store__separator mb-20" />
          <div className="find-a-store__collapsible">
          <div className="find-a-store__store-details row">
            {storeListArray?.map((storeItem, idx) => {
              return (
                <div className="find-a-store__store-row" key={idx}>
                  <div className="find-a-store__store-name">
                    {storeItem.storeName.toUpperCase()}
                  </div>
                  {storeItem?.storeOwnerName && (
                    <div className="find-a-store__store-owner-name">
                      {`${storeItem?.storeOwnerName},`}
                    </div>
                  )}
                  <div className="find-a-store__store-address-primary">
                    {storeItem.addressLine1}
                  </div>
                  {storeItem.addressLine2 && (
                    <div className="find-a-store__store-address-secondary">
                      {storeItem.addressLine2}
                    </div>
                  )}
                  <div className="find-a-store__store-address-zone">
                    {storeItem.city}, {storeItem.state}
                    {" - "}
                    {storeItem.zip}
                  </div>
                  {storeItem?.mobile.length > 0 && (
                    <div
                      onClick={() =>
                        contactClickAnalytics(
                          storeItem?.mobile[0],
                          storeItem?.zip,
                          storeItem?.storeName
                        )
                      }
                    >
                      <span className="find-a-store__store-mobile find-a-store__store-bold">
                        {`${staticTexts?.mobile} : `}
                      </span>
                      {storeItem?.mobile?.map((mobile, index) => {
                        return (
                          <a
                            href={`tel:${mobile}`}
                            className="find-a-store__store-mobile find-a-store__store-bold"
                          >
                            {`${mobile}${
                              index < storeItem.mobile.length - 1 ? ", " : ""
                            }`}
                          </a>
                        )
                      })}
                    </div>
                  )}
                  {storeItem?.phone.length > 0 && (
                    <div>
                      <span className="find-a-store__store-mobile find-a-store__store-bold">
                        {`${staticTexts?.phone} : `}
                      </span>
                      {storeItem?.phone?.map((phone, index) => {
                        return (
                          <a
                            href={`tel:${phone}`}
                            className="find-a-store__store-mobile find-a-store__store-bold"
                          >
                            {`${phone}${
                              index < storeItem.phone.length - 1 ? ", " : ""
                            }`}
                          </a>
                        )
                      })}
                    </div>
                  )}
                  {storeItem.email.length > 0 && (
                    <div
                      onClick={() =>
                        emailClickAnalytics(
                          storeItem?.email[0],
                          storeItem?.zip,
                          storeItem?.storeName
                        )
                      }
                    >
                      <span className="find-a-store__store-mobile find-a-store__store-bold">
                        {`${staticTexts?.email} : `}
                      </span>
                      {storeItem?.email?.map((email, index) => {
                        return (
                          <a
                            href={`mailto:${email}`}
                            className="find-a-store__store-email"
                          >
                            {`${email}${
                              index < storeItem.email.length - 1 ? ", " : ""
                            }`}
                          </a>
                        )
                      })}
                    </div>
                  )}
                  <div className="find-a-store__store-live-area find-a-store__store-bold">
                    {`${staticTexts?.liveArea} :`}{" "}
                    {storeItem.liveArea ? "Yes" : "No"}
                  </div>
                </div>
              )
            })}
            </div>
          </div>{" "}
        </>
      ) : (
        <NoStoreAvailable staticTexts={staticTexts} error={error} />
      )}
    </div>
  )
}

export default ServiceLocatorListing
